import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import MoneyLabel from '../label/MoneyLabel';

const TopClientsList = ({ topClients, amountMode = 'net' }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  if (!topClients || topClients.length === 0) return null;

  // Backend currently only returns `gross`. If we ever add `net`, switch here.
  const valueOf = (client) =>
    amountMode === 'net' ? client.net ?? client.gross ?? 0 : client.gross ?? 0;
  const max = Math.max(...topClients.map(valueOf));

  return (
    <Box className="flex flex-col gap-1.5">
      <Typography
        variant="caption"
        sx={{ color: colors.text, opacity: 0.7, fontWeight: 500 }}
      >
        {t('Top clients')}
      </Typography>
      <Box className="flex flex-col gap-1">
        {topClients.map((client) => {
          const value = valueOf(client);
          const widthPct = max > 0 ? (value / max) * 100 : 0;
          return (
            <Box key={`${client.type}-${client.id}`} className="flex flex-col gap-0.5">
              <Box className="flex items-center justify-between">
                <Typography
                  variant="caption"
                  sx={{
                    color: colors.text,
                    fontSize: '0.78rem',
                    fontWeight: 500,
                  }}
                  className="truncate max-w-[60%]"
                >
                  {client.name} <span style={{ opacity: 0.5 }}>· {client.count}</span>
                </Typography>
                <MoneyLabel money={value} variant="caption" />
              </Box>
              <Box
                sx={{
                  width: '100%',
                  height: 4,
                  borderRadius: 2,
                  backgroundColor: colors.bgInput,
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    width: `${widthPct}%`,
                    height: '100%',
                    backgroundColor: colors.primary?.[500] ?? colors.colorPool?.[0],
                    transition: 'width 0.3s ease',
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default TopClientsList;
